import React from 'react'
import AllTechnologies from '../components/TechnologyPage/AllTechnologies'
import react from '../assets/images/react.svg'
import next from '../assets/images/next.svg'
import vite from '../assets/images/vite.svg'
import redux from '../assets/images/redux.svg'
import node from '../assets/images/node.svg'
import express from '../assets/images/express.svg'
import django from '../assets/images/django.svg'
import QTPy from '../assets/images/qtpy.svg'
import mongoDB from '../assets/images/mongoDB.svg'
import sql from '../assets/images/sql.svg'
import pocketBase from '../assets/images/pocketBase.svg'
import reactNative from '../assets/images/reactNative.svg'
import flutter from '../assets/images/flutter.svg'
import kotlin from '../assets/images/kotlin.svg'
import aws from '../assets/images/aws.svg'
import docker from '../assets/images/docker.svg'
import microsoftAzure from '../assets/images/microsoft.svg'
import jenkins from '../assets/images/jenkins.svg'
import openAI from '../assets/images/openAi.svg'
import langchain from '../assets/images/langChain.svg'
import huggingFace from '../assets/images/huggingFace.svg'
import playwrite from '../assets/images/playwrite.svg'
import microsoftTeams from '../assets/images/microsoftTeams.svg'
import projectManagement from '../assets/images/projectManagementSystem.svg'
import figma from "../assets/images/figma.svg"
import illustrator from "../assets/images/illus.svg"
import photoshop from "../assets/images/photoshop.svg"
import adobexd from "../assets/images/adobexd.svg"

const Technologies = [
  {
    id: 1,
    title: "Frontend Development",
    description:
      "We build responsive, interactive interfaces with fast load times and rich user experiences.",
    card: [
      { image: react, title: "React.js" },
      { image: next, title: "Next.js" },
      { image: vite, title: "Vite" },
      { image: redux, title: "Axios, Redux" },
    ],
  },
  {
    id: 2,
    title: "Backend Development",
    description:
      "Our backend systems are designed for performance, extensibility, and maintainability.",
    card: [
      { image: node, title: "Node.js with Knex" },
      { image: django, title: "Django" },
      { image: express, title: "Express.js" },
      { image: QTPy, title: "QTPy" },
    ],
  },
  {
    id: 3,
    title: "Database Systems",
    description:
      "We use a range of relational and NoSQL databases tailored to your data structure and scale.",
    card: [
      { image: mongoDB, title: "MongoDB" },
      { image: sql, title: "sql" },
      { image: pocketBase, title: "Pocketbase" },
    ],
  },
  {
    id: 4,
    title: "Mobile Application Development",
    description:
      "We create native and cross-platform mobile apps focused on performance and user engagement.",
    card: [
      { image: reactNative, title: "React Native" },
      { image: kotlin, title: "Kotlin" },
      { image: flutter, title: "Flutter" },
    ],
  },
  {
    id: 5,
    title: "Cloud Infrastructure & DevOps",
    description:
      "We deploy and manage cloud-native applications with high availability and automation.",
    card: [
      { image: aws, title: "AWS" },
      { image: microsoftAzure, title: "Microsoft Azure" },
      { image: docker, title: "Docker" },
      { image: jenkins, title: "Jenkins" },
    ],
  },
  {
    id: 6,
    title: "AI & Automation",
    description:
      "We're also equipped to integrate emerging AI technologies into client projects.",
    card: [
      { image: openAI, title: "OpenAI" },
      { image: huggingFace, title: "Hugging Face" },
      { image: langchain, title: "LangChain" },
      { image: playwrite, title: "Playwright" },
    ],
  },
  {
    id: 7,
    title: "UI/UX Design",
    description:
      "We're also equipped to integrate emerging AI technologies into client projects.",
    card: [
      { image: figma, title: "Figma" },
      { image: illustrator, title: "Illustrator" },
      { image: photoshop, title: "Photoshop" },
      { image: adobexd, title: "Adobe XD" },
    ],
  },
  {
    id: 8,
    title: "Communication & Project Management",
    description:
      "We maintain full transparency and smooth collaboration throughout the project lifecycle.",
    card: [
      { image: microsoftTeams, title: "Microsoft Teams " },
      { image: projectManagement, title: "Project Management System " },
    ],
  },
];

const Technology = () => {
    return (
        <div className='w-full flex items-center justify-center pt-[80px] pb-[120px]'>
            <div className='w-[90%] flex flex-col lg:gap-[94px] md:gap-[60px] xs:gap-[40px]'>

                {/* ----------------------------------------------------------------- Provided Our Services Header With Background Image and Gradient layer --------------------------------------------------------------------------------- */}

                <div className='relative w-full flex items-center justify-center bg-technologyBg bg-cover bg-center bg-no-repeat lg:rounded-[110px] sm:rounded-[67px] xs:rounded-[50px] 1400:py-[121px] lg:py-[80px] md:py-[60px] sm:py-[50px] xs:py-[30px]'>
                    {/* <div className="absolute bg-inner inset-0 bg-gradient-to-r from-[#1FA2FF] from-[0%] via-25% to-[#A6FFCB] to-[70%] opacity-20 lg:rounded-[110px] sm:rounded-[67px] xs:rounded-[50px]"></div> */}
                    <div className='lg:w-[calc(100%-220px)] md:w-[calc(100%-100px)] sm:w-[calc(100%-60px)] xs:w-[calc(100%-20px)] flex flex-col gap-[10px] text-center font-faustina  text-[#EEEEEE]'>
                        <p className='font-bold lg:text-[50px] md:text-[40px] xs:text-[32px]'>Technology Stack</p>
              <p className='font-medium md:text-[24px] xs:text-[18px]'>Param Consulting Services Inc. builds secure, scalable digital solutions using
                            a full-stack tech approach from UI to AI.</p>
                    </div>
                </div>

                {/* ----------------------------------------------------------------- Provided Our Services Header With Background Image and Gradient layer --------------------------------------------------------------------------------- */}

                {/* ----------------------------------------------------------------- Page Contente -------------------------------------------------------------------------------------------------------------------------------------------- */}

                <div className='flex flex-col lg:gap-[111px] md:gap-[60px] xs:gap-[40px]'>
                    
            <p className='font-poppins font-regular lg:text-[24px] xs:text-[clamp(18px,2.4vw,24px)] text-justify text-white lg:leading-[45px] md:leading-[40px] xs:leading-[30px]'>At Param Consulting Services Inc., we use a powerful and versatile technology stack to build secure, scalable, and future-ready digital solutions. Our tools and platforms span across all layers of development from UI design to DevOps, from mobile apps to AI automation ensuring excellence at every level.</p>
                    {/* -------------------------------------------------------------- All Technology Container ------------------------------------------------------------------------------------------------------------------------------*/}

                    <div className='flex flex-col gap-[60px] w-full'>
                        {Technologies?.map((technology, i) => (
                            <AllTechnologies
                                title = {technology.title}
                                desc={technology.description}
                                cards = {technology.card}
                            />
                        ))}
                    </div>
                    {/* -------------------------------------------------------------- All Technology Container ------------------------------------------------------------------------------------------------------------------------------*/}

                </div>
                {/* ----------------------------------------------------------------- Page Contente -------------------------------------------------------------------------------------------------------------------------------------------- */}

            </div>
        </div>
    )
}

export default Technology